import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class HomeSlider {

  constructor(){
    this.slider = jQuery('#js--home-slider');
    this.navigation = jQuery('#js--home-slider__nav');
    this.owl = this.slider.data('owlCarousel');
    this.numSlider = parseInt(0);
    this.intervalId = '';
    this._init();
    this.numberOfSlide = jQuery('.numberOfSlide').length;
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){

        this.navigation.find('li').eq(this.numSlider).addClass('js--active').siblings().removeClass('js--active');
        jQuery('#js--home-slider__nav').attr('numero',this.numSlider);

        const carousel = this.slider.owlCarousel({
          items:           1,
          nav:             false,
          navText:         ['',''],
          dots:            true,
          autoplay:        false,
          loop:            true,
          //URLhashListener: false,
          //startPosition:   'URLHash',
          //autoplayTimeout   : 4000,
          smartSpeed        : 800,
        });

        this.owl = this.slider.data('owlCarousel');

        // this.navigation.on('click', 'li', function(){
        //   var currentIndex = jQuery(this).index();
        //   jQuery('#js--home-slider__nav').attr('numero',currentIndex);
        //   jQuery(this).addClass('js--active').siblings().removeClass('js--active');

        //   //this.executeTimer();
        // });

        this.slider.on('changed.owl.carousel', function(event) {
          this.numSlider = event.property.value - parseInt(2);
          jQuery('#js--home-slider__nav').attr('numero',this.numSlider);
          jQuery('#js--home-slider__nav').find('li').eq(this.numSlider).addClass('js--active')
          .siblings().removeClass('js--active');
        });

        this.executeTimer(carousel);

      }  

    });
  }



  executeTimer(carousel){
    clearInterval(this.intervalId);
    let slidesNulmber = this.numberOfSlide;
    
    var radius = 1.2, // set the radius of the circle
      circumference = 2 * radius * Math.PI; 
  
    var els = document.querySelectorAll('circle');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('stroke-dasharray', circumference + 'em');
      el.setAttribute('r', radius + 'em');
    });

    var slide = parseInt(document.querySelector('#js--home-slider__nav').getAttribute('numero')) + parseInt(1);  
    document.querySelector('.radial-progress-center').setAttribute('r', (radius - 0.02 + 'em'));
    
    var currentCount = 1, 
        maxCount = 66, offset = '0em';

    this.intervalId = setInterval(function () { 
      if (currentCount > maxCount) {
        document.querySelector('.radial-progress-cover--'+slide).setAttribute('stroke-dashoffset', '0em');
        currentCount = 0;
        offset = '0em';
        if(slide === slidesNulmber){ slide = 0;}
        //slide suivante
        carousel.trigger('to.owl.carousel', slide);
        slide = slide + 1;
      } else {
        offset = -(circumference / maxCount) * currentCount + 'em';
      }
      document.querySelector('.radial-progress-cover--'+slide).setAttribute('stroke-dashoffset', offset);
          
      currentCount++;
    }, 60);
  }

}

export const homeSlider = new HomeSlider();




